import React from 'react';
import { Phone, Mail, Facebook, Instagram, Twitter, Youtube } from 'lucide-react';
import { dojoData } from '../mock';

const Footer = () => {
  const { locations } = dojoData;
  const mainLocation = locations[0]; // Use the main location for footer

  const socialLinks = [
    { icon: Facebook, href: '#', label: 'Facebook' },
    { icon: Instagram, href: '#', label: 'Instagram' },
    { icon: Twitter, href: '#', label: 'Twitter' },
    { icon: Youtube, href: '#', label: 'YouTube' }
  ];

  return (
    <footer className="section-padding" style={{ backgroundColor: 'var(--bg-light)', color: 'var(--text-on-light)' }}>
      <div className="container">
        {/* Single Footer Bar */}
        <div className="flex flex-col lg:flex-row justify-between items-center gap-6">
          
          {/* Contact Info */}
          <div className="flex flex-col sm:flex-row items-center gap-6">
            <div className="flex items-center gap-3">
              <Phone size={20} style={{ color: 'var(--brand-primary)' }} />
              <a 
                href={`tel:${mainLocation.phone}`}
                className="body-small hover:underline transition-all"
                style={{ color: 'var(--brand-primary)' }}
              >
                {mainLocation.phone}
              </a>
            </div>
            
            <div className="flex items-center gap-3">
              <Mail size={20} style={{ color: 'var(--brand-primary)' }} />
              <a 
                href={`mailto:${mainLocation.email}`}
                className="body-small hover:underline transition-all"
                style={{ color: 'var(--brand-primary)' }}
              >
                {mainLocation.email}
              </a>
            </div>
          </div>

          {/* Social Media Links */}
          <div className="flex flex-col items-center gap-3 sm:flex-row sm:gap-4">
            <span className="body-small" style={{ color: 'var(--text-on-light)' }}>Suivez-nous :</span>
            <div className="flex items-center gap-2">
              {socialLinks.map((social, index) => {
                const IconComponent = social.icon;
                return (
                  <a
                    key={index}
                    href={social.href}
                    className="p-2 rounded-full transition-all hover:scale-110"
                    style={{ 
                      backgroundColor: 'var(--brand-primary)',
                      color: 'white'
                    }}
                    aria-label={social.label}
                  >
                    <IconComponent size={18} />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Copyright & Utility Links */}
          <div className="flex flex-col items-center lg:items-end gap-2">
            <p className="body-small" style={{ color: 'var(--text-on-light)' }}>
              © 2025 Cercle Cadurcien d'Aïkido
            </p>
            <div className="flex gap-4">
              <a href="#" className="body-small hover:text-opacity-80 transition-colors"
                 style={{ color: 'var(--text-secondary-light)' }}>
                Politique de données
              </a>
              <a href="#" className="body-small hover:text-opacity-80 transition-colors"
                 style={{ color: 'var(--text-secondary-light)' }}>
                Termes de service
              </a>
            </div>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
